var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatchSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 10a.625.625 0 1 0 0 1.25h.625v1.339A8.752 8.752 0 0 0 20 30a8.75 8.75 0 0 0 6.613-14.48.583.583 0 0 0 .016-.015l.442-.442.442.442a.625.625 0 1 0 .884-.884l-1.768-1.768a.625.625 0 1 0-.884.884l.442.442-.442.442a.583.583 0 0 0-.015.016 8.717 8.717 0 0 0-4.48-2.048V11.25h.625a.625.625 0 1 0 0-1.25h-3.75zm2.5 7v4.25a.624.624 0 0 1-.625.625h-4.375a.625.625 0 1 1 0-1.25h3.75V17a.625.625 0 1 1 1.25 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatchSmall);
export default __webpack_public_path__ + "static/media/stopwatch-small.36fc903860e606415f9efc8a8be2b462.svg";
export { ForwardRef as ReactComponent };